import { get as getProjection } from 'ol/proj';
import { getTransform } from 'ol/proj';
import { transformExtent, transform } from 'ol/proj';

class Geocoder {
	
	constructor() {
	}
	
	setMap(map) {
		this.view = map.getView();
		
		const wgs84 = getProjection('EPSG:4326');
		this.wgs84 = wgs84;
		this.projection = map.getView().getProjection()
		this.transform = getTransform(this.projection, wgs84);
	}
	
	search(query) {		
	}
	
	geometry(entry) {
		return entry.geometry
	}
	
	getCenter() {
		const center = this.view.getCenter();
		return transform(center, this.projection, this.wgs84);
	}
	
	getExtent() {
		const extent = this.view.calculateExtent();
		return transformExtent( extent, this.projection, this.wgs84 );
	}
	
	create(name, geometry) {
		return { name: name, geometry: geometry }
	}
	
}

export { Geocoder }